import classNames from 'classnames';
import {
  faDownLeftAndUpRightToCenter,
  faUpRightAndDownLeftFromCenter,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations } from 'next-intl';

interface ExpandCollapseBtnProps {
  isFullyExpanded: boolean;
  onClick: () => void;
}

export const ExpandCollapseBtn: React.FC<ExpandCollapseBtnProps> = ({
  isFullyExpanded,
  onClick,
}) => {
  const t = useTranslations();

  return (
    <button type="button" onClick={onClick} className={styles.btn}>
      <FontAwesomeIcon
        icon={
          isFullyExpanded
            ? faDownLeftAndUpRightToCenter
            : faUpRightAndDownLeftFromCenter
        }
        className={styles.icon}
      />
      <span>
        {isFullyExpanded
          ? t('memoComposer.collapse')
          : t('memoComposer.expand')}
      </span>
    </button>
  );
};

const styles = {
  btn: classNames(
    'inline-flex shrink-0 items-center gap-1.5 py-1 px-2.5 border rounded-full text-xs font-medium',
    'text-ink-secondary border-stroke hover:bg-surface-field focus:outline-hidden',
  ),
  icon: 'text-[10px] font-semibold',
};
